(function() {
  function initTyreFinder() {
    const form = document.getElementById('tyre-finder-form');
    if (!form) return;

    const inputs = form.querySelectorAll('select');
    const resetButton = document.getElementById('tyre-finder-reset');
    const formatSelect = document.getElementById('tyre-format');
    const metafields = ['tyre_format', 'tyre_width', 'tyre_aspect_ratio', 'tyre_size'];

    const updateLabels = (format) => {
      const labelWidth = document.getElementById('label-width');
      const labelAspect = document.getElementById('label-aspect');
      const labelSize = document.getElementById('label-size');

      if (format === 'imperial') {
        labelWidth.textContent = 'Width (inches)';
        labelAspect.textContent = 'Diameter (inches)';
        labelSize.textContent = 'Rim size (inches)';
      } else {
        labelWidth.textContent = 'Width';
        labelAspect.textContent = 'Aspect ratio (%)';
        labelSize.textContent = 'Size (inches)';
      }
    };

    const populateSelect = (select, values, selectedValue) => {
      select.innerHTML = '';
      const defaultOption = document.createElement('option');
      defaultOption.value = '';
      defaultOption.textContent = 'Select';
      select.appendChild(defaultOption);

      if (values.every(v => !isNaN(v))) values.sort((a, b) => parseFloat(a) - parseFloat(b));

      values.forEach(value => {
        const option = document.createElement('option');
        option.value = value;
        const display = parseFloat(value) == parseInt(value) ? parseInt(value).toString() : value;
        option.textContent = display;
        if (value === selectedValue) option.selected = true;
        select.appendChild(option);
      });
    };

    const currentFormat = new URLSearchParams(window.location.search).get('filter.p.m.custom.tyre_format') || '';
    if (formatSelect) {
      formatSelect.value = currentFormat;
      updateLabels(currentFormat);
    }

// Populate dropdowns directly
    document.querySelectorAll('select[data-filter-source]').forEach(select => {
      const key = select.dataset.filterSource;
      if (key === 'tyre_format') return;

      const checkboxes = document.querySelectorAll('input[name="filter.p.m.custom.' + key + '"]');
      const values = new Set();

      checkboxes.forEach(input => {
        values.add(input.value);
      });

      const selected = new URLSearchParams(window.location.search).get('filter.p.m.custom.' + key) || '';
      populateSelect(select, Array.from(values), selected);
    });

    // Clean up decimal display in sidebar filters
    document.querySelectorAll('input[name="filter.p.m.custom.tyre_width"]').forEach(input => {
      const label = input.nextElementSibling;
      if (label) {
        const text = label.textContent;
        const match = text.match(/^([\d.]+)(.*)/);
        if (match) {
          const num = parseFloat(match[1]);
          const rest = match[2];
          if (num == parseInt(num)) {
            label.textContent = parseInt(num) + rest;
          }
        }
      }
    });

    function showLoadingOverlay() {
      const overlay = document.getElementById('tyre-finder-loading-overlay');
      if (overlay) {
        overlay.style.display = 'flex';
      }
    }

    inputs.forEach(select => {
      select.addEventListener('change', () => {
        const params = new URLSearchParams(window.location.search);

        if (select.id === 'tyre-format') {
          metafields.forEach(key => params.delete('filter.p.m.custom.' + key));
          if (select.value) {
            params.set('filter.p.m.custom.tyre_format', select.value);
          }
        } else {
          metafields.forEach(key => params.delete('filter.p.m.custom.' + key));
          inputs.forEach(input => {
            if (input.value !== '') params.set(input.name, input.value);
          });
        }

        sessionStorage.setItem('scrollToTyreFinder', 'true');
        showLoadingOverlay();
        window.location.href = params.toString()
          ? window.location.pathname + '?' + params.toString()
          : window.location.pathname;
      });
    });

    resetButton.addEventListener('click', () => {
      form.reset();
      const params = new URLSearchParams(window.location.search);
      metafields.forEach(key => params.delete('filter.p.m.custom.' + key));
      sessionStorage.setItem('scrollToTyreFinder', 'true');
      showLoadingOverlay();
      window.location.href = window.location.pathname;
    });

    if (sessionStorage.getItem('scrollToTyreFinder')) {
      sessionStorage.removeItem('scrollToTyreFinder');
      const finder = document.getElementById('tyre-finder-form');
      if (finder) {
        const offset = 150;
        const finderPosition = finder.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: finderPosition, behavior: 'smooth' });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTyreFinder);
  } else {
    initTyreFinder();
  }
})();